import React from 'react';
import { useMobileContext } from '../../contexts/MobileContext';
import PageShell from '../Layout/PageShell';
import SubPageHero from './SubPageHero';
import ScrollFadeWrapper from '../ScrollFadeWrapper/ScrollFadeWrapper';

import PartnerBrandsComponent from '../HomePage/PartnerBrands/PartnerBrandsComponent';
import PartnerBrandsMobileComponent from '../HomePage/PartnerBrands/PartnerBrandsMobileComponent';
import partnerBrandsData from '../../json/components/HomePages/MedicalAidCompanies/partnerBrandsData.json';

import LifeInsuranceCompaniesListComponent from '../HomePage/LifeInsuranceCompaniesList/LifeInsuranceCompaniesListComponent';
import LifeInsuranceCompaniesListMobileComponent from '../HomePage/LifeInsuranceCompaniesList/LifeInsuranceCompaniesListMobileComponent';
import medicalAidCompaniesListData from '../../json/components/HomePages/MedicalAidCompanies/medicalAidCompaniesListData.json';

function MedicalAidCompaniesPage({ pathName, heroGateKey, onHeroImageLoad }) {
  const isMobile = useMobileContext();

  return (
    <PageShell gap={{ xs: '24px', sm: '48px', md: '64px' }}>
      <SubPageHero
        pathName={pathName}
        heroGateKey={heroGateKey}
        onImageLoad={onHeroImageLoad}
      />

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <PartnerBrandsComponent data={partnerBrandsData} />
        ) : (
          <PartnerBrandsMobileComponent data={partnerBrandsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <LifeInsuranceCompaniesListComponent
            data={medicalAidCompaniesListData}
          />
        ) : (
          <LifeInsuranceCompaniesListMobileComponent
            data={medicalAidCompaniesListData}
          />
        )}
      </ScrollFadeWrapper>
    </PageShell>
  );
}

export default MedicalAidCompaniesPage;
